import React from "react";
import { map } from "lodash";
import { connect } from "react-redux";

import FontIcon from "react-md/lib/FontIcons";

import {
  setActiveHost,
  setActiveServer,
  setActiveOrganization
} from "../../actions/activeActions";
import {DebugElement} from "../../Atollon/debug";
import {getInstanceUrlFromIdent} from "../../constants";

const Table = ({
  history,
  host,
  server,
  organizations,
  setActiveHost,
  setActiveServer,
  setActiveOrganization
}) => {
  return (
    <div className="table">
      <DebugElement text={"/src/components/server/Table.js"}/>
      <div className="table-row header">
        <div className="table-col">Název</div>
        <div className="table-col">ID</div>
        <div className="table-col">Atollon ID</div>
        <div className="table-col actions">Akce</div>
      </div>
      {map(organizations, (item, i) => (
        <div
          className="table-row"
          key={item.id}
          onClick={() =>
            history.push(`/hosts/${host.id}/${server.id}/${item.id}`)}
        >
          <div className="table-col">{item.name}</div>
          <div className="table-col">{getInstanceUrlFromIdent(item.ident)}</div>
          <div className="table-col">{item.atollonId}</div>
          <div className="table-col actions">
            <FontIcon
              className="icon"
              onClick={e => {
                e.stopPropagation();
                setActiveHost(host);
                setActiveServer(server);
                setActiveOrganization(item);
                history.push("/remove-organization");
              }}
            >
              delete
            </FontIcon>
          </div>
        </div>
      ))}
    </div>
  );
};

export default connect(null, {
  setActiveHost,
  setActiveServer,
  setActiveOrganization
})(Table);



// WEBPACK FOOTER //
// ./src/components/server/Table.js